import { render, staticRenderFns } from "./PresentAddress.vue?vue&type=template&id=25ee8a02&"
import script from "./PresentAddress.vue?vue&type=script&lang=js&"
export * from "./PresentAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports